
export const firebaseConfig = {
    apiKey: "AIzaSyBTNY3mgsrSDE_f0AJ9TyaHOgbJjVcVCwA",
    authDomain: "shoppylive-5c68f.firebaseapp.com",
    databaseURL: "https://shoppylive-5c68f.firebaseio.com",
    projectId: "shoppylive-5c68f",
    storageBucket: "shoppylive-5c68f.appspot.com",
    messagingSenderId: "35848306123",
    appId: "1:35848306123:web:cd740334decaf4057dca4e",
    measurementId: "G-LVXJHF9H9L"
  };

